import { GridApi } from 'ag-grid-community';
import { useRef } from 'react';
import { Node } from 'slate';
import { getFormattedValue } from 'src/utils/getFormattedValue';
import useOnClickOutside from 'use-onclickoutside';

import { ScrumColumn, useAgileStore } from '../../store';
import { StatusColors, typeOptions } from './CellRenderers';

export const StatusCellEditor = ({
  data: item,
  api,
  onChange,
}: {
  data: any;
  api: GridApi;
  onChange: (val: ScrumColumn) => void;
}) => {
  const myRef = useRef(null);
  const columnOptions = useAgileStore((s) => s.columns);

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  const handleStatusCell = async (value: ScrumColumn) => {
    if (item._id) {
      onChange(value);
    }
    api.stopEditing();
  };

  return (
    <div ref={myRef} className="bg-white w-150">
      {columnOptions.map((column) => {
        return (
          <div
            onClick={() => handleStatusCell(column)}
            key={column._id}
            className="flex px-10 w-full h-40 text-center items-center justify-center text-sm text-black font-medium"
            style={{ backgroundColor: StatusColors[column.type] }}
          >
            {column.name}
          </div>
        );
      })}
    </div>
  );
};

export const TypeCellEditor = ({
  data: item,
  api,
  onChange,
}: {
  data: any;
  api: GridApi;
  onChange: (val: any) => void;
}) => {
  const myRef = useRef(null);

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  const handleTypeCell = async (value) => {
    if (item._id) {
      onChange(value.type);

      // api.applyTransaction({ update: [{ ...item, type: value?.type }] });
    }
    api.stopEditing();
  };

  return (
    <div ref={myRef} className="bg-white w-100">
      {typeOptions.map((labelOption) => {
        return (
          <div
            onClick={() => handleTypeCell(labelOption)}
            key={labelOption.id}
            className="flex px-10 h-40 items-center "
          >
            <span className="mr-8 block">{labelOption.icon}</span>
            <span className="text-sm block  font-medium">
              {labelOption.name[0].toUpperCase() + labelOption.name.substring(1)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export const EpicCellEditor = ({
  data: item,
  api,
  onChange,
}: {
  data: any;
  api: GridApi;
  onChange: (val: any) => void;
}) => {
  const myRef = useRef(null);
  const epics = useAgileStore((s) => s.epics);

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  const handleEpicCell = async (value) => {
    if (item._id) {
      onChange(value._id);
      // api.applyTransaction({ update: [{ ...item, epic: value?._id }] });
    }
    api.stopEditing();
  };

  return (
    <div ref={myRef} className="bg-white w-130">
      {epics.map((epic) => {
        return (
          <div
            onClick={() => handleEpicCell(epic)}
            key={epic._id}
            className="flex px-10 h-40 items-center "
          >
            <span className="leading-10 text-black px-6 py-4 text-xs font-semibold rounded-sm block mr-4 max-w-185 truncate">
              {getFormattedValue(epic.name)}
            </span>
          </div>
        );
      })}
      {!epics.length && (
        <div className="flex px-10 h-40 items-center max-w-185">
          <span className="text-gray-600 px-6 py-4 text-xs font-semibold rounded-sm block mr-4 truncate">
            No epics found
          </span>
        </div>
      )}
    </div>
  );
};
